import React from 'react';
function Copy({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.462 10h-6.923c-.85 0-1.539.689-1.539 1.539v6.923c0 .85.689 1.538 1.539 1.538h6.923c.85 0 1.538-.689 1.538-1.538v-6.923c0-.85-.689-1.539-1.538-1.539zM6.308 14h-.77A1.539 1.539 0 014 12.461V5.538A1.539 1.539 0 015.538 4h6.923A1.538 1.538 0 0114 5.538v.77"
      />
    </svg>
  );
}

export default Copy;
